import ContactCreate from './Create'
import ContactEdit from './Edit'
import ContactList from './List'

export default {
  list: ContactList,
  create: ContactCreate,
  edit: ContactEdit
}
